const API_BASE = {
   // url: "https://devfood.nzttool.it/apisrc/public/api/",
   url: "https://food.nzttool.it/apisrc/public/api/"
   // url: "http://localhost/nztsync/nztsync_food_back/public/api/",
}

export default API_BASE;
